export const handleAxiosSuccess = res => res.data
export const handleAxiosError = error => (error.response
  ? error.response.data
  : {
    ok: false,
    error: {
      code: 503,
      name: 'NETWORK_ERROR'
    }
  })

export const getUserString = user => `${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}`

export const chain = async (...functionsReturningPromise) => {
  let result

  for (const f of functionsReturningPromise) {
    result = await f()
    if (!result) {
      return {
        ok: false,
      }
    }
    if (!result.ok) {
      break
    }
  }
  return result
}
